import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

let ChangePasswordForm = (props) => {
    const { handleSubmit, pristine, submitting } = props;
    const { t } = useTranslation(['settings']);

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: '100%', width: '50rem' }}>
            <Field
                component={RenderField}
                type="password"
                name="old_password"
                placeholder={t('changePassword.oldPasswordInputPlaceholder')}
                label={t('changePassword.oldPasswordInputLabel')}
                required
            />

            <Field
                component={RenderField}
                type="password"
                name="new_password"
                placeholder={t('changePassword.newPasswordInputPlaceholder')}
                label={t('changePassword.newPasswordInputLabel')}
                required
            />
            <Field
                component={RenderField}
                type="password"
                name="confirm_new_password"
                placeholder={t('changePassword.confirmPasswordPlaceholder')}
                label={t('changePassword.confirmPasswordInputLabel')}
                required
            />
            <Field
                component="input"
                type="hidden"
                name="access_token"
                style={{ display: 'none' }}
            />
            <input
                type="submit"
                value={t('changePassword.changepasswordFormSubmitLabel')}
                disabled={pristine || submitting}
            />
        </form>
    );
};

const RenderField = ({ input, label, type, meta: { touched, error }}) => {
    const { t } = useTranslation(['settings'])
    return (
        <div className="form-group">
            <div>
                <input {...input} placeholder={label} type={type} />
                {touched && error && <span className="input-error">{t(`changePassword.${error}`)}</span>}
            </div>
        </div>
    );
};

const validate = (values) => {
    const errors = {};
    if (!values.old_password) {
        errors.old_password = 'oldPasswordInputFieldErrorMessage';
    }

    if (!values.new_password) {
        errors.new_password = "newPasswordInputFieldErrorMessage";
    } else if (values.new_password.length < 6) {
        errors.new_password = "newPasswordInputFieldLengthErrorMessage";
    } else if (values.new_password !== values.confirm_new_password) {
        errors.confirm_new_password = "passwordInputsMismatchErrorMessage";
        errors.new_password = "passwordInputsMismatchErrorMessage";
    }

    return errors;
};

ChangePasswordForm = reduxForm({
    form: 'changePasswordForm',
    validate
})(ChangePasswordForm);

ChangePasswordForm = connect((state) => ({
    initialValues: {
        access_token: state.session.user.credentials
            ? state.session.user.credentials.accessToken
            : ''
    },
    enableReinitialize: true
}))(ChangePasswordForm);

export default ChangePasswordForm;
